// extracted by mini-css-extract-plugin
module.exports = {"secure-checkout":"_1b8Ie","secureCheckout":"_1b8Ie","secure-checkout-lock":"_2Muc8","secureCheckoutLock":"_2Muc8","secure-checkout-text":"NtIgF","secureCheckoutText":"NtIgF"};